import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Building2, Plane } from "lucide-react";
import api from "../lib/api";
import { Spinner, Pill } from "../components/common";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setA(null); setErr(false);
    api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto px-5 py-24 text-center text-muted-foreground">Article not found.</div>;
  if (!a) return <Spinner full />;

  return (
    <div data-testid="article-detail" className="max-w-3xl mx-auto px-5 lg:px-8 py-10">
      <Link to="/news" className="inline-flex items-center gap-1 text-sm text-primary hover:underline mb-4"><ArrowLeft className="w-4 h-4" /> News</Link>
      <div className="flex flex-wrap gap-1 mb-3">{a.tags?.map((t) => <Pill key={t} tone="blue">{t}</Pill>)}</div>
      <h1 className="font-heading font-900 text-3xl sm:text-4xl tracking-tight leading-tight">{a.title}</h1>
      <p className="mt-3 text-lg text-muted-foreground">{a.summary}</p>
      <div className="mt-2 text-xs font-mono text-muted-foreground">{new Date(a.published_at).toLocaleDateString()}</div>
      <div className="mt-8 prose max-w-none whitespace-pre-line leading-relaxed text-zinc-800">{a.body}</div>

      {a.linked_entities?.length > 0 && (
        <div className="mt-10 border-t border-zinc-200 pt-6">
          <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-3">Related profiles</div>
          <div className="flex flex-wrap gap-2">
            {a.linked_entities.map((e, i) => (
              <Link key={i} to={e.entity_type === "airport" ? `/airports/${e.entity_id}` : `/airlines/${e.entity_id}`}
                className="inline-flex items-center gap-2 border border-zinc-300 bg-white px-3 py-2 text-sm hover:border-primary transition-colors">
                {e.entity_type === "airport" ? <Building2 className="w-4 h-4 text-primary" /> : <Plane className="w-4 h-4 text-primary -rotate-45" />}
                {e.entity_name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
